import axios from 'axios'
import Immutable from 'immutee'

import { getApiUrl, hasPandora } from '../utils/utils'

export const FETCH_AUTOCOMPLETECAR = 'buyer/autocomplete/FETCH_AUTOCOMPLETECAR'
export const FETCH_AUTOCOMPLETECAR_FAILURE =
  'buyer/autocomplete/FETCH_AUTOCOMPLETECAR_FAILURE'

const initialState = {
  fetched: false,
  result: [],
  error: null,
}

export default function reducer(state = initialState, action) {
  const immutable = Immutable(state)
  switch (action.type) {
    case FETCH_AUTOCOMPLETECAR:
      return immutable.set('result', action.payload).set('fetched', true).done()

    case FETCH_AUTOCOMPLETECAR_FAILURE:
      return immutable
        .set('error', action.payload)
        .set('result', [])
        .set('fetched', false)
        .done()

    default:
      return state
  }
}

export function fetchAutoCompleteCar() {
  const url = `${getApiUrl()}filter/car/autocomplete`
  const pandora = hasPandora()
  const requestConfig = {
    params: { pandora },
  }

  return dispatch => {
    return axios
      .get(url, requestConfig)
      .then(res => {
        dispatch({
          type: FETCH_AUTOCOMPLETECAR,
          payload: res.data,
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_AUTOCOMPLETECAR_FAILURE,
          payload: err.stack,
        })
      })
  }
}
